import React from 'react';
import {
  Copy,
  Heading,
  Link,
  Stack,
  Container,
  Row,
  Column,
} from '@grubhubprod/gh-cookbook-react';

export const CORPORATE_LEARNING_CENTER_URL =
  'https://corporate.grubhub.com/learning-center/';

export const CORPORATE_CARE_EMAIL = 'corporatecare@grubhub.com';
export const CORPORATE_ADMIN_SUPPORT_EMAIL = 'corpadminsupport@grubhub.com';
export const BILLING_SUPPORT_EMAIL = 'invoicing@grubhub.com';
export const CORPORATE_CARE_PHONE = '(844) 478-2249';
export const CORPORATE_ADMIN_SUPPORT_PHONE = '(844) 478-2249, option 3';

export function HelpInfoSection(): JSX.Element {
  return (
    <Container variant="default">
      <Stack y="sm">
        <Heading variant="h6">We're here to help</Heading>
      </Stack>
      <Stack y="md">
        <Copy variant="body">
          If you have questions about managing your corporate account, billing,
          or anything related to the corporate admin portal, check out our{' '}
          <Link
            href={CORPORATE_LEARNING_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Corporate Learning Center
          </Link>
          .
        </Copy>
      </Stack>

      <Stack y="md">
        <Row gutter={24}>
          <Column phone={4} gutter={24}>
            <Stack y="x-sm">
              <Copy variant="body" strong>
                CORPORATE CARE
              </Copy>
            </Stack>

            <Stack y="x-sm">
              <Copy variant="body">
                <Link href={`mailto:${CORPORATE_CARE_EMAIL}`}>
                  {CORPORATE_CARE_EMAIL}
                </Link>
              </Copy>
            </Stack>

            <Stack y="x-sm">
              <Copy variant="body">{CORPORATE_CARE_PHONE}</Copy>
            </Stack>

            <Stack y="md">
              <Copy variant="body" strong>
                When To Contact:
              </Copy>
              <ul>
                <li>
                  <Copy variant="body">Problems applying budgets</Copy>
                </li>
                <li>
                  <Copy variant="body">Delivery status updates</Copy>
                </li>
                <li>
                  <Copy variant="body">Password reset requests</Copy>
                </li>
                <li>
                  <Copy variant="body">Order issues</Copy>
                </li>
              </ul>
            </Stack>

            <Stack y="none">
              <Copy variant="body" strong>
                Available:
              </Copy>
            </Stack>
            <Stack y="x-sm">
              <Copy variant="body">
                24 hours a day, 7 days a week for any{' '}
                <Copy variant="body" strong>
                  corporate account user
                </Copy>
              </Copy>
            </Stack>
          </Column>

          <Column phone={4} gutter={24}>
            <Stack y="x-sm">
              <Copy variant="body" strong>
                CORPORATE ADMIN SUPPORT
              </Copy>
            </Stack>
            <Stack y="x-sm">
              <Copy variant="body">
                <Link href={`mailto:${CORPORATE_ADMIN_SUPPORT_EMAIL}`}>
                  {CORPORATE_ADMIN_SUPPORT_EMAIL}
                </Link>
              </Copy>
            </Stack>

            <Stack y="x-sm">
              <Copy variant="body">{CORPORATE_ADMIN_SUPPORT_PHONE}</Copy>
            </Stack>

            <Stack y="xx-lg">
              <Copy variant="body" strong>
                When To Contact:
              </Copy>
              <Copy variant="body">
                <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
                  <li>
                    <Copy variant="body">Admin site troubleshooting</Copy>
                  </li>
                  <li>
                    <Copy variant="body">Account set up questions</Copy>
                  </li>
                </ul>
              </Copy>
            </Stack>
            <Stack y="none">
              <Copy variant="body" strong>
                Available:
              </Copy>
            </Stack>
            <Stack y="x-sm">
              <Copy variant="body">
                Monday-Friday 8:30am-7:30pm ET for any{' '}
                <Copy variant="body" strong>
                  corporate account admins
                </Copy>
                .
              </Copy>
            </Stack>
          </Column>

          <Column phone={4} gutter={24}>
            <Stack y="x-sm">
              <Copy variant="body" strong>
                BILLING SUPPORT
              </Copy>
            </Stack>
            <Stack y="x-sm">
              <Copy variant="body">
                <Link href={`mailto:${BILLING_SUPPORT_EMAIL}`}>
                  {BILLING_SUPPORT_EMAIL}
                </Link>
              </Copy>
            </Stack>
          </Column>
        </Row>
      </Stack>
    </Container>
  );
}
